// note this input component accepts formik prop

import React from 'react';
import PropTypes from 'prop-types';

import {
  STRING_FIELD_PHONE_NUMBER,
} from '../labels';

import FormikLabeledField from './FormikLabeledField';

import formikPropTypes from './formikPropTypes';

export function PhoneNumberField({
  name, onChange, formikProps,
}) {
  return (
    <FormikLabeledField
      name={name}
      onChange={onChange}
      formikProps={formikProps}
      label={STRING_FIELD_PHONE_NUMBER}
      placeholder={STRING_FIELD_PHONE_NUMBER}
      type="tel"
    />
  );
}

PhoneNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  formikProps: formikPropTypes.isRequired,
};

PhoneNumberField.defaultProps = {
  onChange: () => {},
};

export default PhoneNumberField;
